<template>
  <div
    v-if="service.service"
    :key="service.idReservationService"
    class="flex items-center justify-between py-2"
  >
    <div class="leading-none flex items-center">
      <o-avatar :items="[service.service]" class="mr-2" />
      <div>
        <p class="mb-1">
          {{ service.service.title }}
        </p>
        <p class="text-xs opacity-80">
          {{ $t('general.withName', { name: service.employee.displayName }) }}
        </p>
      </div>
    </div>

    <div class="flex flex-shrink-0">
      <div class="pr-3 mr-3 border-r my-auto dark:border-gray-800 font-semibold">
        <ServicePrice :service="service" />
      </div>

      <div
        v-if="discount"
        class="bg-green-400 dark:bg-green-800/20 text-white border-r border-white dark:border-gray-800 rounded-l px-1 text-sm flex items-center truncate"
        :class="{ 'rounded py-2' : !$features.all(['vouchers', 'passes']) }"
        :style="{ 'max-width': '12rem' }"
      >
        <p class="mr-3 leading-none px-1 pt-px">
          <span v-if="customerPass">{{ customerPass.pass.name }}</span>
          <span v-else-if="voucher">{{ voucher.name }} <template v-if="voucher.isDiscountTypeFixed"> {{ $auth.info.location.currencySymbol }}</template>{{ voucher.discountAmount }}<template v-if="voucher.isDiscountTypePercentage">%</template></span>
        </p>
      </div>

      <o-button
        v-if="$features.all(['vouchers', 'passes'])"
        :icon="discount ? 'edit' : 'discount'"
        size="sm"
        :flat="discount ? null : true"
        :variant="discount ? 'success' : null"
        :rounded="discount ? 'rounded-r' : 'rounded'"
        :disabled="provider && provider.unsavedChanges"
        @click="handleEditDiscount"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import ServicePrice from '../elements/ServicePrice.vue'
import { OAvatar } from '@/components/elements'

const { $currency } = useNuxtApp()
const provider = inject<any>('provider')

interface Props {
  service: Record<string, any>
  reservation: Record<string, any>
}

interface Emits {
  (e: 'editDiscount'): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const disabled = ref(false)

const voucher = computed(() => props.service.voucher)
const customerPass = computed(() => props.service.customerPass)
const discount = computed(() => props.service.voucher || props.service.customerPass)

const priceLabel = computed(() => {
  return $currency.format(props.service.price)
})

const discountLabel = computed(() => {
  return $currency.format(props.service.price - (props.service.discountTotal || 0))
})

function handleEditDiscount () {
  emit('editDiscount')
}
</script>
